import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from '../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleManagementService {
  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public list(type: any): Observable<any> {
    return this._httpClient.get(this.url + 'menulist/' + type);
  }

  public access(): Observable<any> {
    return this._httpClient.get(this.url + 'menuaccess');
    //return this._httpClient.get(this.url + 'menuaccess/' + type);
  }

  public save(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'menurights-list', data);
  }
}

